import { SaveActionButtonsComponent } from '../../../components/save-action-buttons/save-action-buttons.component';
import { SaveActionButton } from '../../../components/save-action-buttons/save-action-button.model';
import { CommonModule } from '@angular/common';
import {
  NgbNav,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavContent,
  NgbScrollSpy,
  NgbScrollSpyFragment,
  NgbDropdownModule,
  NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap';
import {
  ConfigStateService,
  LocalizationService,
  SubscriptionService,
  LocalizationModule,
} from '@abp/ng.core';
import { ConfirmationService, ToasterService } from '@abp/ng.theme.shared';
import {
  Component,
  OnInit,
  inject,
  Injector,
  ViewChild,
  computed,
  OnDestroy,
  Signal,
  signal,
  effect,
} from '@angular/core';
import {
  FormBuilder,
  Validators,
  ReactiveFormsModule,
  FormsModule,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { tap, firstValueFrom, Observable } from 'rxjs';
import { BreadcrumbService } from 'xng-breadcrumb';
import {
  AnnexesListComponent,
  CurrentCompanyStore,
  GoliathCoreEnumerationTypeStore,
} from '@digiwall/goliath-core';
import { GoliathContactsEnumerationTypeStore, SalesPersonStore } from '@digiwall/goliath-contacts';
import {
  CreateUpdateCustomerQuoteDto,
  CustomerQuoteDefaultValueDto,
  CustomerQuoteDto,
  CustomerQuoteService,
  DayBookService,
  CustomerQuoteVersionLookupDto,
} from '@digiwall/goliath-documents/proxy';

import {
  ClassificationTypeService,
  DocRole,
  DwActiveLookupRequestDto,
  LabelSubContext,
} from '@digiwall/goliath-core/proxy';
import { GoliathDocumentsEnumerationTypeStore } from '../../../enumeration-types/enumeration-type.store';
import { DocTemplateService } from '../../base-docs/detail/doc-template-selection/doc-template.service';
import { ReportViewerComponent } from '@odyssey/reporting';
import {
  ChatComponent,
  conditionalValidator,
  DeactivatableComponentService,
  DwDatePickerComponent,
  DwInputAutoCompleteDirective,
  DwInputRequiredDirective,
  DwReadonlyFormDirective,
  ErrorFormControlDirective,
  getMergedLookupSelect,
  HistoryComponent,
  LoadingService,
  OdysseyOffcanvas,
} from '@digiwall/core';
import moment from 'moment';
import { BaseCustomerDocDetail } from '../../base-customer-docs/base-customer-doc-detail';
import { FieldMapping } from '../../base-third-party-docs/base-third-party-doc-detail';
import { DocReportPermission } from '@digiwall/goliath-documents/config';
import QuoteLinesEditorComponent from './quote-lines/quote-lines-editor.component';
import {
  CounterComponent,
  DropdownMenu,
  DropdownMenuComponent,
  PanelComponent,
} from '@digiwall/ui-kit';
import { DwGridDetailNavigationComponent, DwTabsComponent } from '@digiwall/ag-grid';
import { DwNavLinkDirective } from '@digiwall/core';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { DwKeyboardShortcutDirective } from '@digiwall/core';
import { DwScrollSpyDirective } from '@digiwall/ag-grid';
import { default as LineEditorDefault } from './quote-lines/quote-lines-editor.component';
import { DocConditionsComponent } from '../../base-docs/detail/doc-conditions/doc-conditions.component';
import { DocClassificationsComponent } from '../../base-docs/detail/doc-classifications/doc-classifications.component';
import { DocCustomerAddressesComponent } from '../../base-docs/detail/doc-customer-addresses/doc-customer-addresses.component';
import { DocCustomerOthersComponent } from '../../base-docs/detail/doc-customer-others/doc-customer-others.component';
import { AsyncPipe } from '@angular/common';
import { SidePanelComponent } from '@digiwall/ui-kit';
import { DialogBoxComponent } from '@digiwall/ui-kit';
import { DocPricingService } from '../../../services/pricing/doc-pricing-service.service';
import { DocOrigin } from '../../../enumeration-types/doc-origin.enum';
import { DocSidePanelComponent } from '../../base-docs/detail/doc-ui-components/doc-side-panel/doc-side-panel.component';
import {
  DocumentCoreCardComponent,
  DocumentCustomerCardComponent,
  DocumentCustomerDateCardComponent,
  DocumentCustomerStatusCardComponent,
  DocumentDocFundingComponent,
} from '../../../components';
import { NgSelectModule } from '@ng-select/ng-select';
import { QuoteDialogBoxCloneComponent } from './quote-dialog-box-clone/quote-dialog-box-clone.component';
import { QuoteVersionSelectComponent } from './quote-version-select/quote-version-select.component';
import { CustomerQuoteToPurchaseOrderService } from './quote-to-order.service';
import { CustomerService } from '@digiwall/goliath-contacts/proxy';
import { DocNumberTagComponent } from '../../../components/doc-number-tag/doc-number-tag.component';
import { LabelPrinterHelper } from '@digiwall/goliath-products';

@Component({
  selector: 'document-quote-detail',
  templateUrl: './quote-detail.component.html',
  styleUrl: './quote-detail.component.scss',
  providers: [DocTemplateService, SubscriptionService, CustomerQuoteToPurchaseOrderService],
  imports: [
    CommonModule,
    PanelComponent,
    DwTabsComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    DwNavLinkDirective,
    NgbNavContent,
    NgbScrollSpy,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    DwKeyboardShortcutDirective,
    NgbScrollSpyFragment,
    DwScrollSpyDirective,
    LineEditorDefault,
    DocConditionsComponent,
    DocClassificationsComponent,
    DocCustomerAddressesComponent,
    DocCustomerOthersComponent,
    AnnexesListComponent,
    NgbDropdownModule,
    NgbNavOutlet,
    SaveActionButtonsComponent,
    SidePanelComponent,
    FormsModule,
    DialogBoxComponent,
    ReportViewerComponent,
    AsyncPipe,
    LocalizationModule,
    CounterComponent,
    ChatComponent,
    DwGridDetailNavigationComponent,
    DocSidePanelComponent,
    DocumentCoreCardComponent,
    DocumentCustomerCardComponent,
    DocumentCustomerDateCardComponent,
    DocumentCustomerStatusCardComponent,
    DwDatePickerComponent,
    DwInputAutoCompleteDirective,
    DwInputRequiredDirective,
    ErrorFormControlDirective,
    NgSelectModule,
    DropdownMenuComponent,
    DwReadonlyFormDirective,
    QuoteVersionSelectComponent,
    HistoryComponent,
    DocumentDocFundingComponent,
    DocNumberTagComponent,
  ],
})
export class QuoteDetailComponent
  extends BaseCustomerDocDetail<
    CustomerQuoteService,
    CustomerQuoteDto,
    CreateUpdateCustomerQuoteDto,
    CustomerQuoteDefaultValueDto
  >
  implements OnInit, OnDestroy
{
  enumerationTypeStore = inject(GoliathDocumentsEnumerationTypeStore);
  contactEnumerationTypeStore = inject(GoliathContactsEnumerationTypeStore);
  coreEnumerationTypeStore = inject(GoliathCoreEnumerationTypeStore);
  salesPersonStore = inject(SalesPersonStore);
  currentCompanyStore = inject(CurrentCompanyStore);
  protected loadingService = inject(LoadingService);
  quoteToSalesPurchaseService = inject(CustomerQuoteToPurchaseOrderService);

  @ViewChild('quoteLineGrid') quoteLineGrid: QuoteLinesEditorComponent;
  @ViewChild('report') reportViewer: ReportViewerComponent;

  docRole = DocRole.CustomerQuote;
  docOrigin = DocOrigin;

  override get defaultValue() {
    return Object.assign(this.baseDefaultValue, {
      allowPartialDelivery: false,
      isIntern: true,
    });
  }

  protected override saveActionBtns = computed((): SaveActionButton[] => [
    {
      label: this.localizationService.instant('::Save'),
      action: () => this.save(),
      disabled: () => !this.form.dirty,
    },
  ]);

  actions: Signal<DropdownMenu> = computed(() => ({
    groups: [
      this.baseActionsThirdPartyDoc().concat(
        {
          label: 'Doc::ImportDocTemplate',
          icon: 'digi-out-upload',
          action: () => this.importTemplate(),
          visible: computed(() => !this.isClosed()),
        },
        {
          label: '::GeneratePdf',
          icon: 'digi-out-pdf-file',
          action: () => this.generatePdf(this.reportViewer),
        },
        {
          label: 'Doc::CustomerQuote:ToPurchaseOrder',
          icon: 'digi-out-add-file',
          action: () => this.toPurchaseOrder(),
          visible: computed(() => !this.isClosed()),
        },
        {
          label: '::Copy',
          icon: 'digi-out-copy',
          action: () => this.copy(),
        },
        {
          label: 'Doc::RecomputePrices',
          icon: 'digi-out-calculator',
          action: () => this.recomputePrices(),
        },
        {
          label: 'Doc::PrintDocument',
          icon: 'digi-out-print',
          action: () => this.printDocument(),
          enabled: this.canPrintDocument,
        },
        {
          label: 'Doc::PrintLabel',
          icon: 'digi-out-print',
          action: () => this.printLabel(),
        },
      ),
      [
        {
          label: 'Doc::GenerateDocPrintTemplate',
          icon: 'digi-out-edit-square',
          action: () => this.openDesigner(),
          requiredPolicy: DocReportPermission.Create,
        },
        {
          label: 'Doc::GenerateLabelPrintTemplate',
          icon: 'digi-out-edit-square',
          action: () =>
            this.labelPrinterHelper.openDesigner(
              this.entity.id,
              LabelSubContext.CustomerDocOrderInfo,
            ),
        },
      ],
    ],
  }));

  totalAmount: number = 0;
  totalAmountVatIncluded: number = 0;

  private hasSeveralVersions = signal<boolean>(false);

  constructor(
    route: ActivatedRoute,
    router: Router,
    subscriptionService: SubscriptionService,
    private quoteService: CustomerQuoteService,
    formBuilder: FormBuilder,
    toastService: ToasterService,
    breadcrumbService: BreadcrumbService,
    dayBookService: DayBookService,
    localizationService: LocalizationService,
    classificationTypeService: ClassificationTypeService,
    docTemplateService: DocTemplateService,
    injector: Injector,
    config: ConfigStateService,
    customerService: CustomerService,
    confirmationService: ConfirmationService,
    deactivableComponentService: DeactivatableComponentService,
    private docPricingService: DocPricingService,
    protected labelPrinterHelper: LabelPrinterHelper,
  ) {
    super(
      route,
      router,
      subscriptionService,
      quoteService,
      formBuilder,
      toastService,
      breadcrumbService,
      dayBookService,
      localizationService,
      classificationTypeService,
      docTemplateService,
      injector,
      customerService,
      config,
      confirmationService,
      deactivableComponentService,
      labelPrinterHelper,
    );

    effect(() => {
      const entity = this.entitySignal();
      const hasServeralVersions = this.hasSeveralVersions();

      if (entity && hasServeralVersions) {
        this.form.get('companySiteId')?.disable();
        this.form.get('dayBookId')?.disable();
        this.form.get('thirdPartyId')?.disable({ emitEvent: false });
      }
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.init();
  }

  protected override async afterGetEntity(response: CustomerQuoteDto): Promise<void> {
    await Promise.all([this.setThirdPartyService(response.thirdPartyId)]);
    this.updateThirdPartyService(response.thirdPartyRole);
    await super.afterGetEntity(response);

    this.form.get('docOriginId').setValue(this.entity.docOriginId);
  }

  override get formModel() {
    return Object.assign({}, super.formModel, {
      versionName: [null],
      versionNumber: [null],
      validityDate: [
        null,
        conditionalValidator(
          () => this.form.get('documentDate')?.value,
          (control: AbstractControl): ValidationErrors | null => {
            const docDate = this.form?.get('documentDate')?.value;
            const validityDate = control.value;
            if (!docDate || !validityDate) return null;
            return moment(validityDate).isSameOrAfter(docDate, 'day')
              ? null
              : {
                  invalidDate: false,
                };
          },
        ),
      ],
      quoteStatusId: [null, Validators.required],
      requestedDeliveryDate: [
        null,
        conditionalValidator(
          () => this.form.get('documentDate')?.value,
          (control: AbstractControl): ValidationErrors | null => {
            const docDate = this.form?.get('documentDate')?.value;
            const deliveryDate = control.value;
            if (!docDate || !deliveryDate) return null;
            return moment(deliveryDate).isAfter(docDate, 'day')
              ? null
              : {
                  invalidDate: false,
                };
          },
        ),
      ],
      bankId: [null],
      personalContribution: [null],
      totalToBeFunded: [null],
      loanDuration: [null],
      loanRate: [null],
      monthlyPayment: [null],
    });
  }

  override copy() {
    this.formStateService.checkDirtyForm(this.form, () => {
      const modalRef = this.modalService.open(QuoteDialogBoxCloneComponent, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        scrollable: true,
        injector: this.injector,
        size: 'l',
      });
      modalRef.componentInstance.documentId.set(this.entity.id);
      modalRef.componentInstance.docService.set(this.docService);
      modalRef.componentInstance.canCreateVersion.set(!this.isClosed());
      this.annexes$?.subscribe(x => {
        modalRef.componentInstance.areAnnexesIncluded.set(x.length != 0);
      });
    });
  }

  protected recomputePrices() {
    this.docPricingService.recomputePrices(this.entity.id, this.quoteService, () => {
      this.refreshEntity();
      this.toastService.success('Doc::PriceRecomputed');
    });
  }

  toPurchaseOrder() {
    if (this.form.get('litigation').value) {
      this.isLitigationError();
      return;
    }

    this.quoteToSalesPurchaseService
      .toPurchaseOrder(this.entity, this.form)
      .subscribeOnce(salesPurchase => {
        if (salesPurchase) {
          this.router.navigate(['../../sales-purchases', salesPurchase.id], {
            relativeTo: this.route,
          });
        }
      });
  }

  protected override setDefaultValue(response: CustomerQuoteDefaultValueDto) {
    super.setDefaultValue(response);
    this.form.get('deliveryAddress').get('countryId').setValue(response.deliveryAddressCountryId);
  }

  override getEntityCallback(): void {
    this.setThirdPartyService(this.entity.thirdPartyId).subscribeOnce(_ => {
      super.getEntityCallback();
      super.loadThirdParties(this.entity.isClosed);
    });

    this.quoteLineGrid?.lineGrid?.grid?.grid?.api?.redrawRows();
  }

  protected override onThirdPartyChanged = (thirdPartyId: string): void => {
    if (thirdPartyId == null) return;

    firstValueFrom(this.setThirdPartyService(thirdPartyId)).then(_ => {
      super.onThirdPartyChanged(thirdPartyId);
      this.thirdPartyId$.next(thirdPartyId);
    });
  };

  private setThirdPartyService(thirdPartyId): Observable<boolean> {
    return this.customerService.exist(thirdPartyId).pipe(
      tap(exist => {
        this.thirdPartyService = exist ? this.customerService : this.leadService;
        this.thirdPartyService$.next(this.thirdPartyService);
      }),
    );
  }

  protected override getFieldMappings(): FieldMapping[] {
    return [
      ...super.getFieldMappings(),
      { formField: 'representativeCommision', customerField: 'representativeCommission' },
      { formField: 'deliveryModeId', customerField: 'deliveryModeId' },
    ];
  }

  protected override thirdPartySelect = getMergedLookupSelect(
    (params: DwActiveLookupRequestDto<string>) => {
      params.onlyActive = true;
      params.sorting = [{ property: 'name' }];
      params.queryProperties = ['code', 'name'];
      return params;
    },
    (a, b) => a.name?.localeCompare(b.name),
    this.customerService.getLookupList,
    this.leadService.getLookupList,
  );

  protected override isFormDisabled: Signal<boolean> = computed(() => {
    const doc = this.entitySignal();
    const isIntern = doc?.isIntern ?? true;
    const isClosed = this.isClosed();
    return isClosed || (!isIntern && !doc.isDraft);
  });

  protected onVersionLoaded(versions: CustomerQuoteVersionLookupDto[]) {
    this.hasSeveralVersions.set(versions.length > 1);
  }
}
